import React from 'react'
import { InputMask as UiKitInput } from '@elamajs/ui-kit'

import * as Styled from './InputMask.styled'

const InputMask = ({ mask, ...props }) => {
  return <Styled.Input width="100%" mask={mask} as={UiKitInput} {...props} />
}

export default InputMask
